import {
  WORK_PACKAGES_SET,
  WORK_PACKAGE_EDITED,
  WORK_PACKAGE_ADDED,
  WORK_PACKAGE_DELETED,
} from 'src/app/redux/redux-types';
import { reduxWorkPackageTypes } from 'src/types';

export const workPackageDefaultState: reduxWorkPackageTypes.StateType = {
  workPackageList: [],
};

export const workPackageReducer = (
  state = workPackageDefaultState,
  action: reduxWorkPackageTypes.ActionType,
): reduxWorkPackageTypes.StateType => {
  switch (action.type) {
    case WORK_PACKAGES_SET:
      return {
        ...state,
        workPackageList: action.payload,
      };
    case WORK_PACKAGE_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.workPackageList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        workPackageList: [action.payload, ...state.workPackageList],
      };
    case WORK_PACKAGE_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.workPackageList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        workPackageList: [
          ...state.workPackageList.slice(0, updateIndex),
          action.payload,
          ...state.workPackageList.slice(updateIndex + 1),
        ],
      };
    case WORK_PACKAGE_DELETED:
      return {
        ...state,
        workPackageList: state.workPackageList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
